import React from "react";
import { classNames } from "../../../shared/utility";
import { InputNumber } from "primereact/inputnumber";

export default function NumberInputText(props) {
  const {
    parentClass,
    label,
    name,
    onChange,
    value,
    labelOn,
    error,
    explanation,
    ref,
    labelClass,
    suffix,
    ...other
  } = props;

  return (
    <div className={parentClass ? parentClass : null}>
      {labelOn ? (
        <div className="mb-1">
          <label
            htmlFor={name}
            className={classNames(
              labelClass ? labelClass : "text-sm",
              "block font-medium text-gray-900"
            )}
          >
            {label}
          </label>
        </div>
      ) : null}
      <div>
        <InputNumber
          name={name}
          value={value}
          onValueChange={onChange}
          onKeyDown={(e) => e.stopPropagation()}
          ref={ref}
          suffix={suffix}
          {...other}
        />

        {error ? <p className="font-medium text-red-500">{error}</p> : null}
      </div>
    </div>
  );
}
